<template>
  <div class="page-content">
    <h1>{{ $t('v.whiteList.title') }}</h1>

    <v-section top-indent>
      <v-notification-card :icon="'/i_notice.svg'" content-right-indent>
        <div>{{ $t('v.whiteList.recommendationMessageAddToWhitelist') }}</div>
      </v-notification-card>
    </v-section>

    <v-section>
      <v-toolbar :type="4" :title="$t('v.whiteList.titlePlacements')">
        <template #secondRowToolsLeft>
          <v-button
            theme="danger"
            :disabled="!canChangeWhitelistPlacements"
            @click="$refs.deleteDialog.open()"
          >{{ $t('v.whiteList.buttonDelete') }}</v-button>
        </template>
        <template #secondRowToolsRight>
          <v-button
            theme="primary"
            :disabled="!canChangeWhitelistPlacements"
            @click="$refs.manuallyDialog.open()"
          >{{ $t('v.whiteList.buttonAddManually') }}</v-button>

          <v-button
            theme="primary"
            :disabled="!canChangeWhitelistPlacements"
            @click="$refs.fileDialog.open()"
          >{{ $t('v.whiteList.buttonAddFromFile') }}</v-button>
        </template>
      </v-toolbar>

      <hr />

      <div class="table-wrapper">
        <v-placements-table-white-list
          v-loading="loading"
          ref="whiteListTable"
          :data="placements"
          :default-sort="sort"
          :cpl="accountCPL"
          @sort-change="changeSort(whitelistType, $event)"
          @selection-change="selection = $event"
        />

        <v-row justify="center" class="pagination-wrapper" v-if="totalPage">
          <v-pagination
            layout="prev, pager, next"
            :page-size="1"
            :current-page="currentPage"
            :total="totalPage"
            :disabled="loading"
            @current-change="changeCurrentPage(whitelistType, $event)"
          />
        </v-row>
      </div>
    </v-section>

    <!-- dialogs -->
    <!-- delete from list -->
    <v-confirmation-dialog
      v-if="canChangeWhitelistPlacements"
      ref="deleteDialog"
      :title="$t('c.dialog.titleDeleteFromWhiteList')"
      :message="$t('c.dialog.messageDeleteFromWhiteList')"
      @confirm="deletePlacementsFromList()"
    />

    <v-placements-dialog-input
      v-if="canChangeWhitelistPlacements"
      ref="manuallyDialog"
      :type="whitelistType"
      :action="addWhitelistManuallyType"
      @change="fetchPlacements(whitelistType)"
    />

    <v-placements-dialog-file-upload
      v-if="canChangeWhitelistPlacements"
      ref="fileDialog"
      :type="whitelistType"
      :action="addWhitelistFromFileType"
      @uploaded="fetchPlacements(whitelistType)"
    />
  </div>
</template>

<script>
import VPagination from '@/components/common/VPagination.vue'
import VConfirmationDialog from '@/components/common/VConfirmationDialog.vue'
import VPlacementsDialogInput from '@/components/Placements/VPlacementsDialogInput.vue'
import VPlacementsDialogFileUpload from '@/components/Placements/VPlacementsDialogFileUpload.vue'
import VPlacementsTableWhiteList from '@/components/Placements/VPlacementsTableWhiteList.vue'
import VToolbar from '@/components/common/VToolbar.vue'
import VSection from '@/components/common/VSection.vue'
import VRow from '@/components/common/VRow.vue'
import VNotificationCard from '@/components/common/VNotificationCard.vue'
import * as types from '@/store/types'
import * as authorities from '@/utils/authorities'
import storeUtils from '@/mixins/storeUtils'

export default {
  name: 'WhiteList',

  components: {
    VPagination,
    VConfirmationDialog,
    VPlacementsDialogInput,
    VPlacementsDialogFileUpload,
    VPlacementsTableWhiteList,
    VToolbar,
    VSection,
    VRow,
    VNotificationCard
  },

  mixins: [storeUtils],

  data() {
    return {
      whitelistType: types.WHITELIST_PLACEMENTS,
      addWhitelistManuallyType: types.ADD_PLACEMENTS_TO_WHITELIST_MANUALLY,
      addWhitelistFromFileType: types.ADD_PLACEMENTS_TO_WHITELIST_FROM_FILE,
      whiteListDialog: false,
      selection: []
    }
  },

  computed: {
    accountCPL() {
      return this.$store.getters.accountCPL
    },
    loading() {
      return this.$store.state[this.whitelistType].loading
    },
    placements() {
      return this.$store.state[this.whitelistType].list
    },
    currentPage() {
      return this.$store.state[this.whitelistType].params.currentPage
    },
    totalPage() {
      return this.$store.state[this.whitelistType].params.totalPage
    },
    sort() {
      return this.$store.state[this.whitelistType].params.sort
    },
    canChangeWhitelistPlacements() {
      return this.$store.getters.hasAuthorities(
        authorities.CHANGE_WHITELIST_PLACEMENTS
      )
    }
  },

  created() {
    this.fetchPlacements(this.whitelistType)
  },

  destroyed() {
    this.clearPlacements(this.whitelistType)
  },

  methods: {
    changeCurrentPage(type, value) {
      this.updateValue(type, { key: 'currentPage', value })
      this.fetchPlacements(type)
    },

    changeSort(type, { prop, order }) {
      const { prop: oldProp, order: oldOrder } = this.$store.state[
        type
      ].params.sort

      if (prop !== oldProp || order !== oldOrder) {
        this.updateValue(type, { key: 'sort', value: { prop, order } })
        this.fetchPlacements(type)
      }
    },

    updateValue(type, { key, value }) {
      const params = {
        [key]: value
      }

      this.updateParams(type, params)
    },

    fetchPlacements(name) {
      const { loading } = this.$store.state[name]
      if (!loading) this.$store.dispatch(types.FETCH_WHITELIST_PLACEMENTS)
    },

    clearPlacements(name) {
      this.setList(name, [])
      this.updateParams(name, {
        sort: {
          prop: null,
          order: null
        },
        currentPage: 1,
        totalPage: null
      })
    },

    deletePlacementsFromList() {
      const action = 'DELETE'
      const name = this.whitelistType
      const ids = this.selection.map(item => item.id)

      if (ids.length) {
        this.$store
          .dispatch(types.CHANGE_WHITELIST_PLACEMENTS, { name, ids, action })
          .then(() => this.fetchPlacements(name))
      }
    }
  }
}
</script>
